import React from "react";
import { Pagination } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import TableControl from "~/pages/Editor/EditorInformationSystems/TableControl";
import Modal from "~/shared/ui/Fields/Modal";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { OpenModal } from "~/pages/Editor/type";
import { useGetInformationSystemsQuery } from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";
import { TableV2 } from "~/shared/ui/TableV2";

import InfoSystemManagement from "./InfoSystemManagement";
import { getEditorInformationSystemColumns } from "./model/tableAdapter";
import { tableHeader } from "./options";
import { transformDataTable } from "./transformDataTable";
import { DataItem } from "./types";

import s from "./EditorInformationSystem.less";

const EditorInfoSystem = () => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { hasPermission } = usePermissions();
  const { openModal, count, page } = useGetLocationData();
  const { handleCount, handlePage } = usePaginationParams();

  const { data, refetch } = useGetInformationSystemsQuery({
    variables: {
      page: 0,
      count: 25,
    },
    fetchPolicy: "cache-and-network",
  });

  const closeModal = () => {
    setData("openModal", null, "currentId", null);
  };

  const handleRowEdit = (record: { id?: string | number }) => {
    setData("openModal", "Edit", "currentId", record.id);
  };

  const tableItems = data?.PositionGetter?.getInformationSystems?.items;
  const total = data?.PositionGetter?.getInformationSystems?.total;
  const transformedTableItems = transformDataTable(tableItems as DataItem[]);

  return (
    <div className={s.wrapper_edit}>
      <div className={s.header_edit}>
        <div>
          <span className={s.title_edit}>{t("info_system.is")}</span>
        </div>
        <div>
          <TableControl createPermission="employeeAccounting.information.system.create" />
          <Modal
            isOpen={Boolean(openModal)}
            title={t(
              openModal === OpenModal.Edit
                ? "information_system.editInfoSystem"
                : "information_system.addInfoSystem",
            )}
            actionClose={closeModal}
          >
            <InfoSystemManagement refetch={refetch} closeModal={closeModal} />
          </Modal>
        </div>
      </div>
      <div className={s.editor_table}>
        <TableV2
          columns={getEditorInformationSystemColumns(t, tableHeader)}
          dataSource={transformedTableItems}
          onRowEdit={
            hasPermission("employeeAccounting.information.system.update")
              ? handleRowEdit
              : undefined
          }
          wrapperClassName={s.editor_table}
        />
        <Pagination
          count={count}
          page={page + 1}
          totalCount={total}
          onChangeCount={handleCount}
          onChangePage={handlePage}
        />
      </div>
    </div>
  );
};

export default EditorInfoSystem;
